import { render } from "./SetServiceManufactureCost.vue?vue&type=template&id=727bc820"
import script from "./SetServiceManufactureCost.vue?vue&type=script&lang=js"
export * from "./SetServiceManufactureCost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__